enum ApiStatus {
    Pending = 'Pending',
    Success = 'Success',
    Error = 'Error',
}

export default ApiStatus;
